import { SupplierRegistrationProcessInstructionType } from '@app/domain/commonSupplierRegistration';
import { InstructionFormDetails } from '../commonAfterFormPage/InstructionFormDetails';
import { ACHFormDetails } from './afterFormPage/ACHChaseAfterForm';
import { ArgentinaLightFrictionFormDetails } from './afterFormPage/ArgentinaLightFrictionAfterForm';
import { BarclaysEuroFormDetails } from './afterFormPage/BarclaysEuroAfterForm';
import { BarclaysGBPFormDetails } from './afterFormPage/BarclaysGBPAfterForm';
import { BarclaysPingPongFormDetails } from './afterFormPage/BarclaysPingPongAfterForm';
import { BarclaysUSDFormDetails } from './afterFormPage/BarclaysUSDAfterForm';
import { BOFAWireFormDetails } from './afterFormPage/BOFAWireAfterForm';
import { BOFAWirePingPongFormDetails } from './afterFormPage/BOFAWirePingPongAfterForm';
import { CanadaPayoneerPingPongFormDetails } from './afterFormPage/CanadaPayoneerPingPongAfterForm';
import { ChileLightFrictionFormDetails } from './afterFormPage/ChileLightFrictionAfterForm';
import { HSBCEuroFormDetails } from './afterFormPage/HSBCEuroAfterForm';
import { HSBCPingPongFormDetails } from './afterFormPage/HSBCPingPongAfterForm';
import { ILLinkedAccountAfterForm } from './afterFormPage/ILLinkedAccountAfterForm';
import { IPSBarclaysEuroAfterForm } from './afterFormPage/IPSBarclaysEuroAfterForm';
import { IPSBOFAWireFormDetails } from './afterFormPage/IPSBOFAWireAfterForm';
import { IPSHSBCEuroAfterForm } from './afterFormPage/IPSHSBCEuroAfterForm';
import { JapanPayoneerFormDetails } from './afterFormPage/JapanPayoneerAfterForm';
import { LeumiFormDetails } from './afterFormPage/LeumiAfterForm';
import { MexicoFrictionlessFormDetails } from './afterFormPage/MexicoFrictionlessAfterFormSpecialComponent.tsx/MexicoFrictionlessAfterForm';
import { NiumBarclaysAfterForm } from './afterFormPage/NiumBarclaysAfterForm';
import { NiumHSBCAfterForm } from './afterFormPage/NiumHSBCAfterForm';
import { PingPongCADTwentyFormDetails } from './afterFormPage/PingPongCADTwentyAfterForm';
import { PingPongUSDFormDetails } from './afterFormPage/PingPongUSDAfterForm';
import { PoalimFormDetails } from './afterFormPage/PoalimAfterForm';
import { VietnamLightFrictionFormDetails } from './afterFormPage/VietnamLightFrictionAfterForm';

export const getInstructionFormDetails = (
  instructionType: SupplierRegistrationProcessInstructionType | undefined,
): InstructionFormDetails => {
  switch (instructionType) {
    case SupplierRegistrationProcessInstructionType.achChaseWireTransfer:
      return ACHFormDetails;
    case SupplierRegistrationProcessInstructionType.incomingPaymentSecurityLeumiUSBankWireTransfer:
    case SupplierRegistrationProcessInstructionType.leumiUSBankWireTransfer:
      return LeumiFormDetails;
    case SupplierRegistrationProcessInstructionType.bofaWirePingPong:
      return BOFAWirePingPongFormDetails;
    case SupplierRegistrationProcessInstructionType.NiumBarclays:
      return NiumBarclaysAfterForm;
    case SupplierRegistrationProcessInstructionType.NiumHSBC:
      return NiumHSBCAfterForm;
    case SupplierRegistrationProcessInstructionType.pingPongUSD:
      return PingPongUSDFormDetails;
    case SupplierRegistrationProcessInstructionType.pingPongCADTwenty:
      return PingPongCADTwentyFormDetails;
    case SupplierRegistrationProcessInstructionType.canadaPayoneerPingPong:
      return CanadaPayoneerPingPongFormDetails;
    case SupplierRegistrationProcessInstructionType.barclaysGBP:
      return BarclaysGBPFormDetails;
    case SupplierRegistrationProcessInstructionType.barclaysUSD:
      return BarclaysUSDFormDetails;
    case SupplierRegistrationProcessInstructionType.IPSBarclaysEUR:
      return IPSBarclaysEuroAfterForm;
    case SupplierRegistrationProcessInstructionType.IPSHSBCEUR:
      return IPSHSBCEuroAfterForm;
    case SupplierRegistrationProcessInstructionType.barclaysEUR:
      return BarclaysEuroFormDetails;
    case SupplierRegistrationProcessInstructionType.hsbcEUR:
      return HSBCEuroFormDetails;
    case SupplierRegistrationProcessInstructionType.barclaysPingPong:
      return BarclaysPingPongFormDetails;
    case SupplierRegistrationProcessInstructionType.hsbcPingPong:
      return HSBCPingPongFormDetails;
    case SupplierRegistrationProcessInstructionType.poalimBankWireTransfer:
    case SupplierRegistrationProcessInstructionType.incomingPaymentSecurityPoalimBankWireTransfer:
      return PoalimFormDetails;
    case SupplierRegistrationProcessInstructionType.japanPayoneer:
      return JapanPayoneerFormDetails;
    case SupplierRegistrationProcessInstructionType.mexicoFrictionless:
    case SupplierRegistrationProcessInstructionType.mexicoAlternative:
      return MexicoFrictionlessFormDetails;
    case SupplierRegistrationProcessInstructionType.argentinaLF:
      return ArgentinaLightFrictionFormDetails;
    case SupplierRegistrationProcessInstructionType.chileLF:
      return ChileLightFrictionFormDetails;
    case SupplierRegistrationProcessInstructionType.vietnamLF:
      return VietnamLightFrictionFormDetails;
    case SupplierRegistrationProcessInstructionType.ilLinkedAccount:
      return ILLinkedAccountAfterForm;
    case SupplierRegistrationProcessInstructionType.IPSBOFAWireTransfer:
      return IPSBOFAWireFormDetails;
    default:
      return BOFAWireFormDetails;
  }
};
